(() => {
  const storageKey = 'drakomarket.appearance.v1';
  const apply = (color) => {
    if (!['arena', 'noche'].includes(color)) return;
    document.documentElement.dataset.drakoAppearance = color;
    document.querySelectorAll('[data-drako-color]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.drakoColor === color));
    });
  };
  try { apply(localStorage.getItem(storageKey)); } catch { /* Browser privacy mode keeps the default. */ }
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-drako-color]');
    if (!button) return;
    apply(button.dataset.drakoColor);
    try { localStorage.setItem(storageKey, button.dataset.drakoColor); } catch { /* Optional preference. */ }
  });
  document.addEventListener('shopify:section:load', () => apply(document.documentElement.dataset.drakoAppearance));
})();

